import React from 'react';
import styles from './ExpedienteLockBanner.module.css';
import Button from '../ui/button';

/**
 * Banner que muestra el estado de bloqueo del expediente
 * - Si el usuario tiene control: muestra que puede editar
 * - Si otro usuario tiene control: permite solicitar control
 * - Si hay una solicitud pendiente: muestra el estado
 */
const ExpedienteLockBanner = ({ 
  lockInfo, 
  pendingTakeoverRequest,
  onRequestControl,
  isConnected,
  isFirstUser
}) => {
  // Usuario tiene control - puede editar
  if (lockInfo.lockedByMe) {
    return ;
  }

  // Otro usuario tiene control
  if (lockInfo.isLocked && lockInfo.lockedBy) {
    const lockedByName = lockInfo.userName || `Usuario ${lockInfo.lockedBy}`;
    
    return (
      <div className={styles.banner} data-status="locked">
        <div className={styles.content}>
          <span className={styles.icon}>🔒</span>
          <div className={styles.messageContainer}>
            <span className={styles.message}>
              <strong>{lockedByName}</strong> está editando este expediente
            </span>
            {pendingTakeoverRequest ? (
              <span className={styles.submessage}>
                Solicitud de control enviada...
              </span>
            ) : (
              <span className={styles.submessage}>
                Solo puedes visualizar. Solicita control para editar.
              </span>
            )}
          </div>
        </div>
        <div className={styles.actions}>
          {pendingTakeoverRequest ? (
            <span className={styles.pending}>⏳ Esperando respuesta...</span>
          ) : (
            <Button 
              variant="secondary" 
              size="small"
              onClick={onRequestControl}
              disabled={!isConnected}
            >
              Solicitar Control
            </Button>
          )}
        </div>
        <div className={styles.statusDot} data-connected={isConnected}></div>
      </div>
    );
  }

  // Nadie tiene control - avisar que el primer usuario tiene capacidad
  return (
    <div className={styles.banner} data-status="available">
      <div className={styles.content}>
        <span className={styles.icon}>👤</span>
        <div className={styles.messageContainer}>
          <span className={styles.message}>
            Eres el primer usuario en acceder a este expediente
          </span>
          <span className={styles.submessage}>
            Tienes capacidad de edición. Los cambios se guardarán automáticamente.
          </span>
        </div>
      </div>
      <div className={styles.statusDot} data-connected={isConnected}></div>
    </div>
  );
};

export default ExpedienteLockBanner;
